export default "__VITE_ASSET__b19db0b6__"